import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { googleLogout } from '@react-oauth/google';
import {
	Button,
	Menu,
	MenuItem,
	useTheme,
	Avatar,
	useMediaQuery,
} from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setLoginModalOpen } from '../../redux/reducers/ui/modalsReducer';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import PATHS from '../../lib/consts/paths';
import './UserMenu.scss';

const UserMenu: FC = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const theme = useTheme();
	const isMobile = useMediaQuery('(max-width:500px)');

	const { data: currentUser } = useUserMeQuery();
	const [userMenu, setUserMenu] = useState<null | HTMLElement>(null);

	const handleUserMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
		setUserMenu(event.currentTarget);
	};

	const handleUserMenuClose = () => {
		setUserMenu(null);
	};

	const logout = async () => {
		googleLogout();
		setUserMenu(null);
		localStorage.removeItem('token');
		localStorage.removeItem('currentUser');
		// await doLogout();
		// push(PATHS.homePage);
		window.location.href = PATHS.homePage;
	};

	const openSignIn = () => {
		dispatch(setLoginModalOpen(true));
	};

	const openUserProfile = () => {
		navigate(`${PATHS.userProfile.root}/${PATHS.userProfile.params.profile}`);
	};

	return currentUser ? (
		<>
			<Button
				className="user-menu-button"
				aria-controls="user-menu"
				aria-haspopup="true"
				onClick={handleUserMenuOpen}
				color="primary"
				sx={{ color: theme.palette.primary.main }}
			>
				{currentUser?.avatar ? (
					<img src={currentUser.avatar} alt={currentUser?.firstName} />
				) : (
					<Avatar
						aria-label="recipe"
						sx={{
							width: '35px',
							height: '35px',
							fontSize: '0.8rem',
							borderRadius: '4px',
							marginRight: '10px',
						}}
					>
						{typeof currentUser?.firstName === 'string' &&
							currentUser?.firstName?.split('')[0]}
					</Avatar>
				)}
				{/* eslint-disable-next-line react/jsx-one-expression-per-line */}
				{!isMobile && (
					<span>
						{t('hey')}, {currentUser.firstName}
					</span>
				)}{' '}
				<ArrowDropDown />
			</Button>

			<Menu
				id="user-menu"
				anchorEl={userMenu}
				keepMounted
				open={Boolean(userMenu)}
				onClose={handleUserMenuClose}
				PaperProps={{
					elevation: 0,
					sx: {
						overflow: 'visible',
						filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
						mt: 1.5,
						'&:before': {
							content: '""',
							display: 'block',
							position: 'absolute',
							top: 0,
							right: 14,
							width: 10,
							height: 10,
							bgcolor: 'background.paper',
							transform: 'translateY(-50%) rotate(45deg)',
							zIndex: 0,
						},
					},
				}}
			>
				<MenuItem onClick={openUserProfile}>{t('myAccount')}</MenuItem>
				<MenuItem onClick={logout}>{t('logout')}</MenuItem>
			</Menu>
		</>
	) : (
		<Button variant="contained" onClick={openSignIn}>
			{t('signIn')}
		</Button>
	);
};

export default UserMenu;
